export default {
    computed: {
        isImage () {
            return this.image
        },
        image () {
            if (this.course.images) {
                return this.course.images.small
            }
            if (typeof this.course.image === 'string') {
                return this.course.image
            }
            return (this.course.image?.isFallbackImage && this.instructorImage) ? this.instructorImage : this.course.image?.url
        },
        instructorImage () {
            if (!this.course.instructor || !this.course.instructor.metadata) {
                return null
            }
            try {
                return JSON.parse(this.course.instructor.metadata).images[0]
            } catch (error) {
                return null
            }
        }
    }
}
